/* eslint-disable */
import React, { useMemo } from 'react';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import FlipCardGrid from '../../components/FlipCardGrid';
import eliIllustration from '../../../../../../assets/student-training/pyde/img2.png';
import fcgImg3 from '../../../../../../assets/student-training/pyde/img3.png';
import fcgImg4 from '../../../../../../assets/student-training/pyde/img4.png';
import fcgImg5 from '../../../../../../assets/student-training/pyde/img5.png';
import fcgImg6 from '../../../../../../assets/student-training/pyde/img6.png';
import stepBg1 from '../../../../../../assets/student-training/pyde/step-bg1.png';
import stepBg2 from '../../../../../../assets/student-training/pyde/step-bg2.png';
import stepBg3 from '../../../../../../assets/student-training/pyde/step-bg3.png';
import stepBg4 from '../../../../../../assets/student-training/pyde/step-bg4.png';
import stepBg5 from '../../../../../../assets/student-training/pyde/step-bg5.png';
import stepIllustration from '../../../../../../assets/student-training/pyde/step-bg.png';
import NumberedStepsIllustration from '../../components/NumberedStepsIllustration';
import { useParams } from 'react-router-dom';
// import {useUpdateComponentState} from "../../../hooks";
import { useStore } from '../../../../store';
import { FCG_ICONS } from './iconMap';
import { useUpdateComponentState } from '../../../hooks';


const STEP_CARD_BACKGROUNDS = [stepBg1, stepBg2, stepBg3, stepBg4, stepBg5];

interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const FCG_ICONS_New = FCG_ICONS.map((render) => render(false));
  const FCG_IMAGES = [fcgImg3, fcgImg4, fcgImg5, fcgImg6];

  const FCG_ITEMS =
    paragraphsSettings?.section2Items?.map((item: any, index: number) => ({
      icon: FCG_ICONS_New[index],
      title: item.title,
      illustration: <img src={FCG_IMAGES[index]} alt="" />,
      content: item.content,
    })) ?? [];

  const onEliComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-pyde-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  const onFcgComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-pyde-section2-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  return (
    <div className="topic-section-2">
      <div style={{ margin: '5rem 0 8rem 0' }}>
        <ExpandableListIllustration
          mainTitle={paragraphsSettings?.title}
          subTitle={paragraphsSettings?.subTitle}
          description={paragraphsSettings?.description}
          illustration={<img src={eliIllustration} alt="" />}
          items={paragraphsSettings?.items}
          id="student-training-pyde-section2-1"
          onComplete={onEliComplete}
        />
      </div>

      <FlipCardGrid
        subTitle={paragraphsSettings?.section2MainTitle}
        description={paragraphsSettings?.section2Desc}
        items={FCG_ITEMS}
        id="student-training-pyde-section2-2"
        onComplete={onFcgComplete}
      />
      <NumberedStepsIllustration
        mainTitle={paragraphsSettings?.section3MainTitle}
        description={paragraphsSettings?.section3Desc}
        illustration={<img src={stepIllustration} alt="" />}
        cardBackgrounds={STEP_CARD_BACKGROUNDS}
        items={paragraphsSettings?.section3Itmes}
      />
    </div>
  );
};

export default Section2;
